
import { CustomSelect, CustomSelectTrigger, CustomSelectValue, CustomSelectContent, CustomSelectItem } from "@/components/ui/custom-select";
import NodeIcon from "./NodeIcon";
import { NODE_CATEGORIES } from "./NodeHeaderConstants";
import { NodeHeaderSelectModeProps } from "./NodeHeaderTypes";

const NodeHeaderSelectMode = ({
  displayCategory,
  onCategorySelect,
  onSelectOpenChange,
  onTriggerClick,
  onContentClick,
  onItemClick
}: NodeHeaderSelectModeProps) => {
  return (
    <div className="nodrag" style={{ pointerEvents: 'all', position: 'relative', zIndex: 20 }}>
      <CustomSelect 
        value={displayCategory} 
        onValueChange={onCategorySelect}
        onOpenChange={onSelectOpenChange}
      >
        <CustomSelectTrigger 
          className="h-5 py-0 px-1 text-xs w-full max-w-[120px] nodrag border-none bg-transparent hover:bg-black/5 focus:bg-black/5"
          onClick={onTriggerClick}
          style={{ pointerEvents: 'all' }}
        >
          <div className="category-text-area">
            <CustomSelectValue />
          </div>
        </CustomSelectTrigger>
        <CustomSelectContent 
          style={{ 
            zIndex: 9999, 
            position: 'fixed',
            pointerEvents: 'all'
          }}
          onClick={onContentClick}
        >
          {NODE_CATEGORIES.map((cat) => (
            <CustomSelectItem 
              key={cat} 
              value={cat}
              onClick={onItemClick}
              style={{ pointerEvents: 'all' }}
            >
              <div className="flex items-center">
                <NodeIcon category={cat} />
                <span className="ml-1">{cat}</span>
              </div>
            </CustomSelectItem>
          ))}
        </CustomSelectContent>
      </CustomSelect>
    </div>
  );
};

export default NodeHeaderSelectMode;
